import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Slots } from '@classes/slots/slots';
import { DataService } from '@services/data/data.service';
import { SlotsService } from '@services/slots/slots.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';

interface Time {
  day: number; hour: number; min: number; sec: number;
}

@Component({
  selector: 'app-smartparking-slots-table',
  templateUrl: './smartparking-slots-table.component.html',
  styleUrls: ['./smartparking-slots-table.component.scss']
})
export class SmartparkingSlotsTableComponent extends SubscriptionBaseComponent implements OnInit {

  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';
  isAdmin: boolean;

  displayedColumnsAdmin: string[] = ['name', 'status', 'statusTime', 'timeLimitExceeded'];
  displayedColumns: string[] = ['name', 'status'];
  dataSource: MatTableDataSource<Slots>;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  idCamera: any;
  keyword: string;

  constructor(
    private slotsService: SlotsService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
    this.getQueryParams();
  }

  formatDate(date: string): Date {
    const dateSplit = date?.split('T');
    const day = parseInt(dateSplit[0]?.split('-')[2], 10);
    const month = (parseInt(dateSplit[0]?.split('-')[1], 10) - 1);
    const year = parseInt(dateSplit[0]?.split('-')[0], 10);

    const hour = parseInt(dateSplit[1]?.split(':')[0], 10);
    const min = parseInt(dateSplit[1]?.split(':')[1], 10);
    const sec = parseInt(dateSplit[1]?.split(':')[2]?.split('Z')[0], 10);

    const newDate = new Date(year, month, day);

    newDate.setHours(hour);
    newDate.setMinutes(min);
    newDate.setSeconds(sec);

    return newDate;

  }

  getTimeLimiteExceeded(date: string, status: string): string {
    const hour = parseInt(date?.split('T')[1]?.split(':')[0], 10);
    const dateStart = new Date(date);
    dateStart.setHours(hour);
    const today = new Date();

    const tE: Time = this.countDiffTime(dateStart, today);

    let time = '';

    status === 'Free' ?
      time = '00:00:00' :
      time = `${tE.day > 0 ? tE.day + ' jour(s)' : ''}  ${tE.hour < 10 ? '0' + tE.hour : tE.hour}:${tE.min < 10 ? '0' + tE.min : tE.min}:${tE.sec < 10 ? '0' + tE.sec : tE.sec}`;

    return time;
  }

  timeIsExceeded(date: string, status: string): boolean {
    const hour = parseInt(date?.split('T')[1]?.split(':')[0], 10);
    const dateStart = new Date(date);
    dateStart.setHours(hour);
    const today = new Date();

    const tE: Time = this.countDiffTime(dateStart, today);

    if (status === 'Occupied' && (tE.day > 0 || tE.hour > 1 || (tE.hour >= 1 && tE.min >= 30))) {
      return true;
    } else if (status === 'Free') {
      return false;
    }



  }

  private countDiffTime(date1, date2) {
    const diff: Time = {
      day: null,
      hour: null,
      min: null,
      sec: null
    };

    // Initialisation du retour
    let tmp = date2 - date1;

    tmp = Math.floor(tmp / 1000);             // Nombre de secondes entre les 2 dates
    diff.sec = tmp % 60;                    // Extraction du nombre de secondes

    tmp = Math.floor((tmp - diff.sec) / 60);    // Nombre de minutes (partie entière)
    diff.min = tmp % 60;                    // Extraction du nombre de minutes

    tmp = Math.floor((tmp - diff.min) / 60);    // Nombre d'heures (entières)
    diff.hour = tmp % 24;                   // Extraction du nombre d'heures

    tmp = Math.floor((tmp - diff.hour) / 24);   // Nombre de jours restants
    diff.day = tmp;

    return diff;
  }

  private getQueryParams(): void {
    this.idCamera = this.route.snapshot.queryParams.id;
    this.getPlaceParking();
  }

  private getPlaceParking(): void {
    this.slotsService.getParkingPlaceByCamera(this.idCamera).subscribe(res => {

      this.dataSource = new MatTableDataSource<Slots>(res);
      // this.dataSource.sortingDataAccessor = (item, property) => {
      //   switch (property) {
      //     case 'name': return item.name;
      //     case 'status': return item.status;
      //     case 'pristatusTimece': return item.statusTime;
      //     case 'timeLimitExceeded': return item.timeLimitExceeded;
      //     default: return item[property];
      //   }
      // };
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  private initSub() {
    this.subscription
      .add(
        this.dataService.isAdmin.asObservable().subscribe(isAdmin => {
          this.isAdmin = isAdmin;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.slotsService.keyword.asObservable().subscribe(keyword => {
          let filterValue = '';
          switch (keyword.toLowerCase()) {
            case 'l':
              filterValue = 'Free';
              break;
            case 'li':
              filterValue = 'Free';
              break;
            case 'lib':
              filterValue = 'Free';
              break;
            case 'libr':
              filterValue = 'Free';
              break;
            case 'libre':
              filterValue = 'Free';
              break;
            case 'o':
              filterValue = 'Occupied';
              break;
            case 'oc':
              filterValue = 'Occupied';
              break;
            case 'occ':
              filterValue = 'Occupied';
              break;
            case 'occu':
              filterValue = 'Occupied';
              break;
            case 'occup':
              filterValue = 'Occupied';
              break;
            case 'occupé':
              filterValue = 'Occupied';
              break;
            case 'occupée':
              filterValue = 'Occupied';
              break;
            default:
              filterValue = keyword;
              break;
          }
          this.dataSource.filter = filterValue.trim().toLowerCase();
          this.cdr.detectChanges();
        })
      );
  }


}
